module.exports = __webpack_public_path__ + "img/pt.7af75ad0.svg";